import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../auth/AuthContext';
import { getGreeting, HOME_PROFILE } from '../../data/home';
import { formatDate } from '../../i18n/format';
import { readWalletAmounts } from '../Wallet/walletData';
import ActivityList from './components/ActivityList';
import ProductGrid from './components/ProductGrid';
import ServiceGrid from './components/ServiceGrid';
import TopUpModal from './components/TopUpModal';
import VoucherPanel from './components/VoucherPanel';
import WalletCard from './components/WalletCard';
import './Home.css';

function Home() {
    const { t, i18n } = useTranslation('home');
    const { t: tCommon } = useTranslation('common');
    const { user, authInitializing, profileLoading, refreshProfile } = useAuth();
    const [hideBalance, setHideBalance] = useState(false);
    const [topUpOpen, setTopUpOpen] = useState(false);
    const wallet = readWalletAmounts(user);
    const walletLoading = authInitializing || profileLoading;

    useEffect(() => {
        void refreshProfile();
    }, [refreshProfile]);
    const firstName = (user?.displayName || HOME_PROFILE.fullName).split(' ')[0];
    const dateLabel = useMemo(
        () => formatDate(new Date(), {
            weekday: 'long',
            day: 'numeric',
            month: 'long',
            year: 'numeric',
        }),
        [i18n.resolvedLanguage]
    );

    return (
        <div className="home">
            <div className="page-heading">
                <div>
                    <p className="home__kicker">{tCommon('nav.home')}</p>
                    <h1>
                        {t('heading.greeting', { greeting: getGreeting(), name: firstName })}
                    </h1>
                    <p>{t('heading.subtitle')}</p>
                </div>
                <span className="date">{dateLabel}</span>
            </div>

            <div className="overview">
                <WalletCard
                    availableCredits={wallet.availableCredits}
                    reservedCredits={wallet.reservedCredits}
                    hideBalance={hideBalance}
                    loading={walletLoading}
                    onToggleBalance={() => setHideBalance((value) => !value)}
                    onTopUp={() => setTopUpOpen(true)}
                />
                <VoucherPanel />
            </div>

            <ServiceGrid />
            {/* <ProductGrid />
            <ActivityList limit={5} /> */}
            <TopUpModal open={topUpOpen} onClose={() => setTopUpOpen(false)} />
        </div>
    );
}

export default Home;
